module.exports = __webpack_public_path__ + "img/152.aa53c85d.png";